"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "bg-white p-5 mb-4"
};
const _hoisted_2 = { class: "uppercase font-bold text-xl border-b-1 border-gray pb-3" };
const _hoisted_3 = { class: "flex flex-col md:flex-row" };
const _hoisted_4 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_5 = { class: "w-56 text-base pt-3" };
const _hoisted_6 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_7 = { class: "w-56 text-base pt-3" };
const _hoisted_8 = {
    key: 0,
    class: "flex flex-col md:flex-row"
};
const _hoisted_9 = { class: "flex items-start w-full py-2" };
const _hoisted_10 = { class: "w-56 text-base pt-3" };
const _hoisted_11 = { class: "flex flex-col md:flex-row" };
const _hoisted_12 = {
    key: 0,
    class: "flex items-start w-full md:w-1/2 py-2"
};
const _hoisted_13 = { class: "w-full" };
const _hoisted_14 = { class: "text-base pt-3" };
const _hoisted_15 = { class: "inline-flex items-start mr-2 pt-3" };
const _hoisted_16 = { class: "flex items-center" };
const _hoisted_17 = { class: "inline font-bold uppercase text-base mr-2" };
const _hoisted_18 = { class: "inline font-bold uppercase text-base" };
const _hoisted_19 = {
    key: 1,
    class: "flex w-full md:w-1/2 py-2 md:pl-3.5"
};
const _hoisted_20 = { class: "flex items-start w-full py-2" };
const _hoisted_21 = {
    key: 0,
    class: "flex flex-col w-full justify-center"
};
const _hoisted_22 = {
    key: 1,
    class: "flex flex-col w-full justify-center !w-fit !grow"
};
const _hoisted_23 = { class: "flex flex-col md:flex-row" };
const _hoisted_24 = { class: "flex flex-col md:flex-row" };
const _hoisted_25 = {
    key: 1,
    class: "flex flex-col md:flex-row"
};
const _hoisted_26 = { class: "grow text-red mt-2 text-sm items-center text-center" };
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const vue_3 = require("vue");
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
const securityStore_1 = require("../../stores/security/securityStore");
const i18n_1 = require("../../common/i18n");
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const CustomerProductReturnShippingModes_1 = require("../../stores/customerProductReturn/CustomerProductReturnShippingModes");
const LocationSelector_vue_1 = __importDefault(require("../../components/Location/LocationSelector.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const customersStore_1 = require("../../stores/customers/customersStore");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CustomerDataForm',
    props: {
        customerProductReturnCreateRequest: {
            type: Object,
        },
    },
    setup(__props) {
        const props = __props;
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const customersStore = (0, customersStore_1.useCustomersStore)();
        let customerAddressesOptions = (0, vue_3.ref)([]);
        let customerTakeAwayAddress = (0, vue_3.ref)("");
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const shippingCustomAddressZipCodeChanged = (zipCode) => {
            if (props.customerProductReturnCreateRequest === undefined) {
                return;
            }
            props.customerProductReturnCreateRequest.shippingZip = zipCode;
        };
        const shippingCustomAddressCityChanged = (city) => {
            if (props.customerProductReturnCreateRequest === undefined) {
                return;
            }
            props.customerProductReturnCreateRequest.shippingCity = city;
        };
        (0, vue_3.onBeforeMount)(async () => {
            if (securityStore.authenticatedUser === null) {
                return;
            }
            try {
                const customer = await customersStore.getCustomer(router, securityStore.authenticatedUser.customer.id);
                if (customer["@type"] !== "Customer") {
                    return;
                }
                customerTakeAwayAddress.value =
                    customer.contactZip +
                        ", " +
                        customer.contactCity +
                        ", " +
                        customer.contactStreet;
                Array.prototype.forEach.call(customer.addresses, (customerAddress) => {
                    customerAddressesOptions.value.push(new DropdownInputItem_1.default(customerAddress.zip +
                        "-" +
                        customerAddress.city +
                        "-" +
                        customerAddress.street, customerAddress.zip +
                        ", " +
                        customerAddress.city +
                        ", " +
                        customerAddress.street +
                        " - " +
                        customerAddress.name, false));
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        });
        const shippingModeOptions = (0, vue_3.ref)([
            new DropdownInputItem_1.default(CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes.TAKE_AWAY, (0, i18n_1.trans)("take_away_shipping_mode", "Take away", "customer_product_return")),
            new DropdownInputItem_1.default(CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes.DELIVERY, (0, i18n_1.trans)("delivery_shipping_mode", "Delivery", "customer_product_return")),
        ]);
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return ((0, vue_2.unref)(securityStore).authenticatedUser !== null &&
                __props.customerProductReturnCreateRequest !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_data", "Customer Data", "customer_product_return")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_name", "Customer name", "customer_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow !bg-gray",
                                border: "",
                                required: "",
                                "model-value": (_a = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _a === void 0 ? void 0 : _a.customer.name,
                                readonly: ""
                            }, null, 8, ["model-value"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipping_mode", "Shipping mode", "customer_product_return")), 1),
                            (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                modelValue: __props.customerProductReturnCreateRequest.shippingMode,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((__props.customerProductReturnCreateRequest.shippingMode) = $event)),
                                required: "",
                                items: shippingModeOptions.value,
                                class: "mb-5 bg-white border border-gray-dark border-opacity-50 !w-fit !grow",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('choose_shipping_mode', 'Choose a shipping mode', 'customer_product_return'),
                                valid: __props.customerProductReturnCreateRequest.isShippingModeValid(),
                                "show-validity": __props.customerProductReturnCreateRequest.shippingMode ==
                                    null ||
                                    __props.customerProductReturnCreateRequest.shippingMode == 0
                            }, null, 8, ["modelValue", "items", "placeholder", "valid", "show-validity"])
                        ])
                    ]),
                    (__props.customerProductReturnCreateRequest.shippingMode ==
                        (0, vue_2.unref)(CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes).TAKE_AWAY)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                            (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("take_away_address", "Takeaway address", "customer_product_return")), 1),
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    class: "!w-fit !grow !bg-gray",
                                    border: "",
                                    required: "",
                                    modelValue: __props.customerProductReturnCreateRequest.shippingAddress,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((__props.customerProductReturnCreateRequest.shippingAddress) = $event)),
                                    "model-value": (0, vue_2.unref)(customerTakeAwayAddress),
                                    readonly: ""
                                }, null, 8, ["modelValue", "model-value"])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                        (__props.customerProductReturnCreateRequest.shippingMode ==
                            (0, vue_2.unref)(CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes).DELIVERY &&
                            ((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission('ALLOW_USER_TRANSFER')))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, [
                                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_equals_end_user", "The address is the same as the customer's address", "customer_product_return")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_equals_end_user_no", "No", "customer_product_return")), 1),
                                            (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                                modelValue: __props.customerProductReturnCreateRequest.customerEqualsEndUser,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((__props.customerProductReturnCreateRequest.customerEqualsEndUser) = $event)),
                                                class: "mx-3"
                                            }, null, 8, ["modelValue"]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_equals_end_user_yes", "Yes", "customer_product_return")), 1)
                                        ])
                                    ])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.customerProductReturnCreateRequest.shippingMode ==
                            (0, vue_2.unref)(CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes).DELIVERY)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, [
                                (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                    (__props.customerProductReturnCreateRequest.customerEqualsEndUser)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_21, [
                                            (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                                modelValue: __props.customerProductReturnCreateRequest.shippingAddress,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((__props.customerProductReturnCreateRequest.shippingAddress) = $event)),
                                                class: "bg-white border border-gray-dark border-opacity-50",
                                                items: (0, vue_2.unref)(customerAddressesOptions),
                                                placeholder: (0, vue_2.unref)(i18n_1.trans)('choose_delivery_address', 'Choose delivery address', 'customer_product_return'),
                                                valid: __props.customerProductReturnCreateRequest.isShippingAddressValid(),
                                                "show-validity": __props.customerProductReturnCreateRequest.shippingAddress ==
                                                    null
                                            }, null, 8, ["modelValue", "items", "placeholder", "valid", "show-validity"])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (((_c = (0, vue_2.unref)(currentUser)) === null || _c === void 0 ? void 0 : _c.hasPermission('ALLOW_USER_TRANSFER')) &&
                                        !__props.customerProductReturnCreateRequest.customerEqualsEndUser)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                                    class: "!flex-row items-center !w-fit !grow mb-3",
                                                    type: "text",
                                                    placeholder: "Transfer name",
                                                    modelValue: __props.customerProductReturnCreateRequest.transferName,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((__props.customerProductReturnCreateRequest.transferName) = $event)),
                                                    valid: __props.customerProductReturnCreateRequest.isTransferNameValid(),
                                                    "show-validity": __props.customerProductReturnCreateRequest.transferName ==
                                                        null ||
                                                        __props.customerProductReturnCreateRequest.transferName ==
                                                            '',
                                                    border: ""
                                                }, null, 8, ["modelValue", "valid", "show-validity"]),
                                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                                    class: "!flex-row items-center !w-fit !grow mb-3 ml-3",
                                                    type: "text",
                                                    placeholder: "06201234545",
                                                    modelValue: __props.customerProductReturnCreateRequest.transferPhone,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((__props.customerProductReturnCreateRequest.transferPhone) = $event)),
                                                    valid: __props.customerProductReturnCreateRequest.isTransferPhoneValid(),
                                                    "show-validity": __props.customerProductReturnCreateRequest.transferPhone ==
                                                        null ||
                                                        __props.customerProductReturnCreateRequest.transferPhone ==
                                                            '',
                                                    border: ""
                                                }, null, 8, ["modelValue", "valid", "show-validity"])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                                (0, vue_2.createVNode)(LocationSelector_vue_1.default, {
                                                    onZipCodeChange: shippingCustomAddressZipCodeChanged,
                                                    onCityChange: shippingCustomAddressCityChanged
                                                }, null, 8, ["onZipCodeChange"]),
                                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                                    class: "!flex-row items-center !w-fit !grow mb-3 ml-3",
                                                    type: "text",
                                                    placeholder: "Nyugati 1 utca 12",
                                                    modelValue: __props.customerProductReturnCreateRequest.shippingStreet,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((__props.customerProductReturnCreateRequest.shippingStreet) = $event)),
                                                    valid: __props.customerProductReturnCreateRequest.isShippingStreetValid(),
                                                    "show-validity": __props.customerProductReturnCreateRequest.shippingStreet ==
                                                        null ||
                                                        __props.customerProductReturnCreateRequest.shippingStreet ==
                                                            '',
                                                    border: ""
                                                }, null, 8, ["modelValue", "valid", "show-validity"])
                                            ])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (__props.customerProductReturnCreateRequest.shippingMode ==
                        (0, vue_2.unref)(CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes).DELIVERY)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, [
                            (0, vue_2.createElementVNode)("div", _hoisted_26, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_product_return_address_info", "All registered returned items will be recorded at this address from now on!", "customer_product_return")), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
